import { render, staticRenderFns } from "./CollectReturnPopup.vue?vue&type=template&id=7d57aa1e&"
import script from "./CollectReturnPopup.vue?vue&type=script&lang=ts&"
export * from "./CollectReturnPopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports